import { z } from 'zod';

export const beneficiarySchema = z.object({
  tipoMovimentacao: z.string().nonempty('Campo obrigatório'),
  checkbox1: z.boolean().optional(),
  checkbox2: z.boolean().optional(),
});

export type BeneficiaryFormSchema = z.infer<typeof beneficiarySchema>;
